import React, { Component } from 'react'
import { Button,Modal, ModalHeader, ModalBody, ModalFooter,Form,FormGroup,Label } from 'reactstrap';
import DropDown from 'shared/components/DropDown/index';
import Input from 'shared/components/Input/index';
import ActionButton from 'shared/components/ActionButton/index';
import TextArea from 'shared/components/Input/text_area';

export default class AccurenceModel extends Component {

  render() {
    return (
          <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className="modal-lg">
            <ModalHeader toggle={this.props.toggle}>Add/Edit Frequency Master</ModalHeader>
            <ModalBody>
           {this.props.frequency_default_data.map(x=>
              <Form key={x.id}>
                <div className="row">
                  <div className="col-md-12">
                      <FormGroup>
                        <Label>Frequency Name</Label>
                        <Input type={"text"} id={"name-"+ x.id} name="name" onBlur={this.props.onBlur} value={x.name} placeholder={""} onChange={this.props.onChange} maxLength={25}/>
                        <span className="error-text">{this.props.validator.message('name', x.name, 'required',false,{default: 'This field is required.'})}</span>
                        {this.props.check_exist_message!=false?<span className="error-text">Record already exist.</span>:''}
                    </FormGroup>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <FormGroup>
                        <Label>Description</Label>
                        <TextArea  id={"description-"+ x.id} placeholder={""} name={"description"} value={x.description} onChange={this.props.onChange} maxLength={200}/>
                        <span className="error-text">{this.props.validator.message('description', x.description, 'required',false,{default: 'This field is required.'})}</span>
                  </FormGroup>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <FormGroup>
                      <Label>Occurrence Type</Label>
                      <DropDown name={"occurrence_type"} id={"occurrence_type-"+x.id} data={this.props.occurence_data} onChange={this.props.onChange} value={x.occurrence_type} first_element={"--Select occurrence--"} />
                      <span className="error-text">{this.props.validator.message('occurrence_type', x.occurrence_type, 'required|gt:0',false,{default: 'This field is required.'})}</span>
                    </FormGroup>
                  </div>
                   <div className="col-md-6">
                   <FormGroup>
                      <Label>Default Occurrence Count </Label>
                      <Input type={"number"} min={0} onChange={this.props.onChange} value={x.occur_frequency} id={"occur_frequency-"+ x.id} name={"occur_frequency"} maxLength={2} />
                      <span className="error-text">{this.props.validator.message('occur_frequency', x.occur_frequency, 'required|min:1|max:2|lte:'+this.props.lte,false,{default: 'This field is required.',max:'Maximum 2 characters allowed',lte:'For selected occurrence occurrence count must be less than or equal to '+this.props.lte})}</span>
                    </FormGroup>
                  </div> 
                </div>

                 <div className="row">
                  <div className="col-md-12">
                    <FormGroup>
                    <Label>Status</Label>
                    <DropDown name={"status"} id={"status-"+x.id} disabled={x.periodical_count>0?true:false}  data={this.props.status_data} onChange={this.props.onChange} value={x.status} first_element={"--Select Status--"} />
                    <span className="error-text">{this.props.validator.message('status', x.status, 'required',false,{default: 'This field is required.'})}</span></FormGroup>
                  </div>
                </div>
                
              </Form>
             )}
            </ModalBody>
            <ModalFooter>
            <ActionButton color={"primary"} size={"md"} button_name={"Save & Close"} button_click={this.props.onSubmitClick}/>{' '}
            <ActionButton color={"danger"} size={"md"} button_name={"Cancel"} button_click={this.props.toggle}/>
            </ModalFooter>
          </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/Models/accurence_model.js